import React, { FC } from 'react';

import { useDesktop, TypographyProps, Typography } from 'Modules/ui3';


export const TitleH1: FC<TypographyProps<'h1'>> = ({ children, ...props }) => {
    const isDesktop = useDesktop();
    return (
        <Typography component='h1' fontSize={isDesktop ? '48px' : '26px'} fontWeight='500' lineHeight='1.25' color='grayscale.shade95' {...props}>
            {children}
        </Typography>
    );
};

export const SectionTitleH1: FC<TypographyProps<'h1'>> = ({ children, ...props }) => {
    const isDesktop = useDesktop();
    return (
        <Typography component='h1' fontSize={isDesktop ? '39px' : '22px'} fontWeight='500' lineHeight='1.25' color='grayscale.shade95' mt={isDesktop ? 16 : 12} {...props}>
            {children}
        </Typography>
    );
};

export const TitleH2: FC<TypographyProps<'h2'>> = ({ children, ...props }) => {
    const isDesktop = useDesktop();
    return (
        <Typography component='h2' fontSize={isDesktop ? '31px' : '18px'} fontWeight='500' lineHeight='1.3' color='grayscale.shade95' {...props}>
            {children}
        </Typography>
    );
};

export const TitleH3: FC<TypographyProps<'h3'>> = ({ children, ...props }) => {
    const isDesktop = useDesktop();
    return (
        <Typography component='h3' variant={isDesktop ? 'regularHeader2' : 'regularBody2'} lineHeight={isDesktop ? '1.5' : '1.4'} color='grayscale.shade90' {...props}>
            {children}
        </Typography>
    );
};
